import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { COBStep } from '~/client-flow/clientOb/ClientOnboarding.constants';
import { routes } from '~/constants';
import { relationshipModel, serviceModel } from '~/models';
import { RelationshipStatus } from '~/models/relationship';
import { formatDateTimeWithLongMonth } from '~/utils';
import { getTimezoneAbbreviation } from '~/utils/date-timezone.utils';
import { customPageStep, customPageStepIndex, getStepName, isCustomPageStep, PreviewState, Reason, stepsTextsPath, termsOfServiceIndexOf } from './ClientOnboarding.common.utils';
export { COBStep, customPageStep, customPageStepIndex, getStepName, isCustomPageStep, PreviewState, stepsTextsPath, termsOfServiceIndexOf };
export function getClientOnboardingEntryRedirect(param) {
    let { relationship, userId, role, isVendor } = param;
    const relationshipId = relationship.id;
    switch(relationship.status){
        case RelationshipStatus.Approved:
            if (relationshipModel.isBuyer(relationship, userId) || relationshipModel.hasClientViewPermission(role)) {
                return {
                    url: routes.agreementMinisiteRoutes(relationshipId).agreement
                };
            }
            return {
                url: routes.noPermissionsRelationshipAlreadyApproved
            };
        case RelationshipStatus.Terminated:
            return relationshipModel.hasClientViewPermission(role) ? {
                url: routes.agreementMinisiteRoutes(relationshipId).agreement
            } : null;
        case RelationshipStatus.Canceled:
            return {
                url: routes.canceledProposalPage
            };
        case RelationshipStatus.Expired:
            return isVendor ? null : {
                url: routes.expiredProposalPage,
                state: {
                    vendorName: relationshipModel.vendorName(relationship)
                }
            };
        default:
            return null;
    }
}
export const withoutCustomerAddressRequirement = (relationship)=>_object_spread_props(_object_spread({}, relationship), {
        requireCustomerAddress: false
    });
export function isAllowedToGoBack(url) {
    return url === routes.canceledProposalPage;
}
export const approveDisabledReasonsTextsPath = 'clientFlow.footer.approveDisabledReasons';
export function reasonToText(reason, texts) {
    let { signingDocumentName = '' } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const map = {
        [Reason.PaymentMethod]: texts.paymentMethod(),
        [Reason.ReviewServices]: texts.reviewServices(),
        [Reason.SelectAPackage]: texts.selectAPackage(),
        [Reason.ReviewerApprove]: texts.reviewerApprove(),
        [Reason.ApproveTermsOfServices]: texts.approveTermsOfServices(),
        [Reason.NotAllowedToSign]: texts.notAllowedToSign(),
        [Reason.SampleApprove]: texts.sampleApprove(),
        [Reason.MissingAddress]: texts.missingAddress(),
        [Reason.CompleteSignatureFields]: texts.completeSignatureFields({
            documentName: signingDocumentName
        })
    };
    return map[reason];
}
export const getInitialSelectedBundleId = (getFromStorage, relationship, userId)=>{
    const fromStorage = getFromStorage('selected_bundle_id');
    if (fromStorage && !relationshipModel.isSignatory(relationship, userId) && !relationshipModel.isReviewer(relationship, userId)) {
        return fromStorage;
    }
    return relationshipModel.selectedBundleId(relationship) || undefined;
};
export const getInitialSelectedOptionalServices = (param)=>{
    let { setToStorage, getFromStorage, isPreview, relationship, selectedBundleID, userId } = param;
    const getInitialSelectedOptionalServices = ()=>{
        const initialSelectedOptionalServices = relationshipModel.includedByDefaultOptionalServices(relationship, selectedBundleID);
        setToStorage('selected_optional_services', initialSelectedOptionalServices);
        return initialSelectedOptionalServices;
    };
    const fromStorage = getFromStorage('selected_optional_services');
    const fromRelationship = relationshipModel.selectedOptionalServices(relationship);
    const hasSelectedOptionalServices = fromRelationship.length > 0;
    if (isPreview) {
        return getInitialSelectedOptionalServices();
    }
    if (fromStorage && !relationshipModel.isSignatory(relationship, userId) && !relationshipModel.isReviewer(relationship, userId)) {
        return fromStorage;
    }
    if (hasSelectedOptionalServices) {
        setToStorage('selected_optional_services', fromRelationship);
        return fromRelationship;
    }
    return getInitialSelectedOptionalServices();
};
export const getInitialSelectedPaymentMethod = (getFromStorage, relationship, userId)=>{
    const selectedPaymentFromStorage = getFromStorage('selected_payment_method');
    if (selectedPaymentFromStorage && !relationshipModel.isSignatory(relationship, userId) && !relationshipModel.isReviewer(relationship, userId)) {
        return selectedPaymentFromStorage;
    } else {
        return {
            fundingSourceId: relationshipModel.selectedFundingSourceId(relationship) || undefined
        };
    }
};
export const limitedTimeDiscountTextsPath = 'clientFlow.limitedTimeDiscount';
export function getExpirationDateMessage(expirationDate, texts) {
    if (!expirationDate) return null;
    const utcMidnight = new Date(Date.UTC(expirationDate.year, expirationDate.month - 1, expirationDate.day + 1, 0, 0, 0, 0));
    const timezoneAbbreviation = getTimezoneAbbreviation(utcMidnight);
    return texts.withDateAndTimezone({
        date: formatDateTimeWithLongMonth(utcMidnight),
        timezone: timezoneAbbreviation || texts.yourTimezone()
    });
}
export function getLimitedTimeDiscountOfferCalloutTextForService(service, texts) {
    const offer = serviceModel.limitedTimeDiscountOffer(service);
    if (!offer) return null;
    const expirationDate = offer.ExpirationDate();
    if (expirationDate) {
        return getExpirationDateMessage(expirationDate, texts);
    }
    const days = offer.ExpirationDays();
    return days ? texts.withDays({
        days
    }) : null;
}
